(function(root){
  function shuffle(input){
    const copy=input.slice();
    for(let i=copy.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];}
    return copy;
  }
  function mix(input){
    const shirts=shuffle(input.filter(x=>x.category==='shirt'));
    const blankets=shuffle(input.filter(x=>x.category==='blanket'));
    if(!shirts.length||!blankets.length)return shuffle(input);
    const first=shuffle([...shirts.splice(0,4),...blankets.splice(0,4)]);
    if(first.length===8){
      for(const parity of [0,1]){
        const slots=[parity,parity+2,parity+4,parity+6];
        if(slots.every(i=>first[i].category===first[slots[0]].category)){
          const other=first.findIndex((x,i)=>i%2!==parity&&x.category!==first[slots[0]].category);
          [first[slots[0]],first[other]]=[first[other],first[slots[0]]];
        }
      }
    }
    return first.concat(shuffle(shirts.concat(blankets)));
  }
  function select(input,category){return category==='all'?input.slice():input.filter(x=>x.category===category);}
  root.HakhatuMomentsEngine={mix,select};
})(typeof window!=='undefined'?window:globalThis);

(function(){
  if(window.HakhatuMomentsInitialize){window.HakhatuMomentsInitialize();return;}
  function initialize(){
  document.querySelectorAll('.pf-reviews:not([data-pf-ready])').forEach(function(root){
    root.dataset.pfReady='true';
    const data=JSON.parse(root.querySelector('.pf-data').textContent);
    const rail=root.querySelector('.pf-rail');
    const photosOnly=root.hasAttribute('data-pf-photos-only');
    const counter=root.querySelector('.pf-counter');
    const live=root.querySelector('.pf-live');
    const previous=root.querySelector('[data-pf-prev]');
    const next=root.querySelector('[data-pf-next]');
    const toggle=root.querySelector('[data-pf-toggle]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let category=root.dataset.pfCategory||'all';
    let selected=[];
    let states=[];
    let animationFrame=0;
    let lastTick=0;
    let stride=0;
    let manuallyPaused=false;
    let suppressClickUntil=0;
    const pauseReasons=new Set(['offscreen']);
    const label=c=>c==='shirt'?'Hawaiian shirt':'Photo blanket';
    const node=(tag,cls,text)=>{const el=document.createElement(tag);el.className=cls;if(text!==undefined)el.textContent=text;return el;};
    function rating(item){
      const row=node('div','pf-rating');
      const stars=node('span','pf-stars','★'.repeat(item.stars)+'☆'.repeat(5-item.stars));
      stars.setAttribute('role','img');stars.setAttribute('aria-label',item.stars+' out of 5 stars');row.append(stars);
      return row;
    }
    function card(item,index){
      const article=node('article','pf-card');article.dataset.reviewId=item.id;article.dataset.category=item.category;
      const photo=node('div','pf-photo');
      const img=node('img','');img.src=item.thumb;if(item.thumb!==item.large&&item.thumbWidth!==item.largeWidth)img.srcset=item.thumb+' '+item.thumbWidth+'w, '+item.large+' '+item.largeWidth+'w';img.sizes='(max-width: 767px) 46vw, (max-width: 1023px) 31vw, 288px';img.alt=item.alt;img.width=item.width;img.height=item.height;img.loading=index<8?'eager':'lazy';img.decoding='async';
      photo.append(img);
      if(photosOnly){article.append(photo);return article;}
      photo.append(node('span','pf-category',label(item.category)));
      const content=node('div','pf-card-content');
      const attr=node('div','pf-attribution');
      const name=node('span','pf-name',item.author);name.title=item.author;
      attr.append(name);content.append(attr,rating(item),node('p','pf-quote',item.text));article.append(photo,content);return article;
    }
    function autoplay(){return !manuallyPaused&&!reduced.matches&&pauseReasons.size===0;}
    function paint(state){state.track.style.transform='translate3d('+state.offset.toFixed(3)+'px,0,0)';}
    function normalize(state){
      if(!stride||!state.track.children.length)return;
      // Recycle only a tile outside the viewport. No cloned reviews or end jump.
      while(state.offset<=-stride){state.track.append(state.track.firstElementChild);state.offset+=stride;}
      while(state.offset>0){state.track.prepend(state.track.lastElementChild);state.offset-=stride;}
    }
    function tick(now){
      animationFrame=0;
      if(!root.isConnected)return;
      const dt=lastTick?Math.min(now-lastTick,48):0;lastTick=now;
      const speed=window.matchMedia('(max-width:767px)').matches?10:16;
      states.forEach(state=>{
        if(autoplay())state.offset+=state.direction*speed*dt/1000;
        if(Math.abs(state.burst)>.1){const movement=state.burst*(1-Math.exp(-dt/85));state.offset+=movement;state.burst-=movement;}
        else state.burst=0;
        normalize(state);paint(state);
      });
      if((autoplay()||states.some(state=>state.burst))&&!pauseReasons.has('offscreen')&&!pauseReasons.has('hidden'))animationFrame=requestAnimationFrame(tick);
      else lastTick=0;
    }
    function syncPlayback(){
      root.dataset.pfPaused=String(!autoplay());
      if(toggle){
      toggle.disabled=reduced.matches;
      toggle.textContent=manuallyPaused||reduced.matches?'Play slideshow':'Pause slideshow';
      toggle.setAttribute('aria-pressed',String(manuallyPaused||reduced.matches));
      toggle.title=reduced.matches?'Automatic motion is off in your device settings':'';
      }
      const running=(autoplay()||states.some(state=>state.burst))&&!pauseReasons.has('offscreen')&&!pauseReasons.has('hidden');
      if(running&&!animationFrame){lastTick=0;animationFrame=requestAnimationFrame(tick);}
      if(!running&&animationFrame){cancelAnimationFrame(animationFrame);animationFrame=0;lastTick=0;}
    }
    function setPause(reason,paused){if(paused)pauseReasons.add(reason);else pauseReasons.delete(reason);syncPlayback();}
    function geometry(reset){
      const style=getComputedStyle(root);
      const columns=Number(style.getPropertyValue('--pf-columns'))||4;
      const gap=parseFloat(style.getPropertyValue('--pf-gap'))||12;
      const width=(rail.clientWidth-(columns-1)*gap)/columns;
      if(width<=0)return;
      const oldStride=stride;stride=width+gap;
      root.style.setProperty('--pf-card-width',width+'px');
      states.forEach((state,i)=>{
        state.offset=reset?(i?-stride*.38:0):oldStride?state.offset/oldStride*stride:0;
        state.burst=0;normalize(state);paint(state);
      });
    }
    function bindLane(state){
      let drag=null;
      state.lane.addEventListener('pointerdown',event=>{
        if(event.button!==0||!event.isPrimary)return;
        drag={id:event.pointerId,x:event.clientX,moved:false};setPause('drag',true);
      });
      state.lane.addEventListener('pointermove',event=>{
        if(!drag||drag.id!==event.pointerId)return;
        const delta=event.clientX-drag.x;
        if(!drag.moved&&Math.abs(delta)<6)return;
        if(!drag.moved){drag.moved=true;state.lane.setPointerCapture(event.pointerId);}
        drag.x=event.clientX;state.offset+=delta;state.burst=0;normalize(state);paint(state);
        if(event.cancelable)event.preventDefault();
      });
      const release=event=>{
        if(!drag||drag.id!==event.pointerId)return;
        if(drag.moved)suppressClickUntil=performance.now()+250;
        if(state.lane.hasPointerCapture(event.pointerId))state.lane.releasePointerCapture(event.pointerId);
        drag=null;setPause('drag',false);
      };
      state.lane.addEventListener('pointerup',release);
      state.lane.addEventListener('pointercancel',release);
      state.lane.addEventListener('lostpointercapture',release);
      state.lane.addEventListener('click',event=>{if(performance.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}},true);
      state.lane.addEventListener('keydown',event=>{
        if(event.target!==state.lane)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();step(event.key==='ArrowRight'?1:-1,state);}
      });
    }
    function render(announce){
      selected=HakhatuMomentsEngine.mix(HakhatuMomentsEngine.select(data,category));
      pauseReasons.delete('drag');suppressClickUntil=0;rail.replaceChildren();states=[];
      if(!selected.length)rail.append(node('p','pf-empty','More customer stories are on their way.'));
      else for(let row=0;row<2;row++){
        const lane=node('div','pf-lane');lane.tabIndex=0;lane.setAttribute('role','group');lane.setAttribute('aria-label','Photo review row '+(row+1)+'. Swipe or use arrow keys to browse.');
        const track=node('div','pf-track');selected.forEach((item,index)=>{if(index%2===row)track.append(card(item,index));});
        lane.append(track);rail.append(lane);
        const state={lane,track,offset:0,direction:row?1:-1,burst:0};states.push(state);bindLane(state);
      }
      if(counter)counter.textContent=selected.length+' photo moments';
      if(previous)previous.disabled=selected.length<2;
      if(next)next.disabled=selected.length<2;
      geometry(true);syncPlayback();
      if(announce&&live)live.textContent=selected.length+' '+(category==='all'?'mixed photo':label(category))+' reviews. A new selection is ready.';
    }
    function step(direction,target){
      const columns=Number(getComputedStyle(root).getPropertyValue('--pf-columns'))||4;
      (target?[target]:states).forEach(state=>{
        const movement=-direction*stride*columns;
        if(reduced.matches){state.offset+=movement;normalize(state);paint(state);}
        else state.burst+=movement;
      });syncPlayback();
    }
    root.querySelectorAll('[data-pf-filter]').forEach(button=>button.addEventListener('click',()=>{
      category=button.dataset.pfFilter;
      root.querySelectorAll('[data-pf-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));render(true);
    }));
    root.querySelectorAll('[data-pf-mix]').forEach(button=>button.addEventListener('click',()=>render(true)));
    previous?.addEventListener('click',()=>step(-1));next?.addEventListener('click',()=>step(1));
    toggle?.addEventListener('click',()=>{manuallyPaused=!manuallyPaused;syncPlayback();});
    rail.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')setPause('hover',true);});
    rail.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')setPause('hover',false);});
    root.addEventListener('focusin',event=>{
      if(!event.target.matches(':focus-visible'))return;
      setPause('focus',true);
      const tile=event.target.closest('.pf-card');const state=tile&&states.find(x=>x.track.contains(tile));
      if(state){
        const index=Array.from(state.track.children).indexOf(tile);
        const tileRect=tile.getBoundingClientRect(),laneRect=state.lane.getBoundingClientRect();
        if(tileRect.left<laneRect.left||tileRect.right>laneRect.right){for(let i=0;i<index;i++)state.track.append(state.track.firstElementChild);state.offset=0;state.burst=0;paint(state);}
        state.lane.scrollLeft=0;
      }
    });
    root.addEventListener('focusout',()=>queueMicrotask(()=>{const active=document.activeElement;if(!root.contains(active)||!active.matches(':focus-visible'))setPause('focus',false);}));
    rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();step(event.key==='ArrowRight'?1:-1);}});
    reduced.addEventListener('change',syncPlayback);
    document.addEventListener('visibilitychange',()=>setPause('hidden',document.hidden));
    new ResizeObserver(()=>geometry(false)).observe(rail);
    new IntersectionObserver(entries=>setPause('offscreen',!entries[0].isIntersecting),{threshold:.02}).observe(rail);
    render(false);
  });
  }
  window.HakhatuMomentsInitialize=initialize;
  document.addEventListener('shopify:section:load',initialize);
  initialize();
})();
